import type { FeaturedCardInput } from "@/types/featuredCard";
import type { ImageCard } from "@/types/pageData";
export interface Input extends FeaturedCardInput {}
$ const { theme = "pink" } = input;
$ const getImageSrc = (image: ImageCard) => {
  if (typeof image === "string") {
    return image;
  }
  return `https://i.ebayimg.com/images/g/${image.zoom}/s-l640.jpg`;
};

<li class=["featured-card", `featured-card--${theme}`]>
  <a
    class="featured-card__storefront-link"
    href=input.storefrontUrl
    on-click("handleStorefrontClick")
  >
    <div class="featured-card__storefront-content">
      <h3 class="featured-card__storefront-name">
        ${input.firstName} ${input.lastName}
      </h3>
      <p class="featured-card__storefront-description">
        ${input.description}
      </p>
      <div class="featured-card__storefront-cta">
        <ebay-button size="small" tabindex="-1">
          <if(input.ctaText)>
            <span>${input.ctaText}</span>
          </if>
          <else>
            <span>Shop ${input.firstName}'s picks</span>
          </else>
        </ebay-button>
      </div>
    </div>

    <div class="featured-card__storefront-images">

      <div class="featured-card__storefront-image">
        <img
          src=input.profileImage
          alt=`${input.firstName} ${input.lastName}`
          loading="lazy"
        >
      </div>
      <for|image| of=input.cards>
        $ const src = getImageSrc(image);
        <div class="featured-card__storefront-image featured-card__storefront-image--scrim">
          <img src=src alt="" loading="lazy">
        </div>
      </for>
    </div>
  </a>
</li>
